import AccountIcon from '@/shared/assets/icons/detail/account.svg?react'
import CardIcons from '@/shared/assets/icons/detail/card.svg?react'
import SBPIcon from '@/shared/assets/icons/detail/sbp.svg?react'

import {
  PaymentRequisiteStatusMap,
  PaymentRequisiteToStatus,
  PaymentRequisiteToType,
} from '@/entities/paymentRequisit'

interface PaymentRequisitIconProps {
  bg?: boolean
  accountType?: PaymentRequisiteToType
  status?: PaymentRequisiteToStatus
  className?: string
}

export const PaymentRequisitIcon = (props: PaymentRequisitIconProps) => {
  const { accountType, status = PaymentRequisiteToStatus.Unknown, bg, className } = props

  const colorKey = PaymentRequisiteStatusMap[status]?.color || 'grey'

  const iconClass = `text-[var(--status-${colorKey}-stroke)]`
  const bgClass = `bg-[var(--status-${colorKey}-fill)]`
  const wrapperClass = bg
    ? `w-10 h-10 flex items-center justify-center rounded-full ${bgClass}`
    : ''

  const iconProps = {
    className: `${iconClass} ${className ?? ''}`,
  }

  const renderIcon = () => {
    switch (accountType) {
      case PaymentRequisiteToType.CardNumber:
        return <CardIcons {...iconProps} />
      case PaymentRequisiteToType.AccountNumber:
        return <AccountIcon {...iconProps} />
      case PaymentRequisiteToType.SbpPhoneNumber:
      default:
        return <SBPIcon {...iconProps} />
    }
  }

  return <div className={wrapperClass}>{renderIcon()}</div>
}
